import { Component } from '@angular/core'
import { AgRendererComponent } from 'ag-grid-angular'

@Component({
  selector: 'app-progress-view-column-renderer',
  template: `
    <div class="btn-group">
      <button
        type="button"
        class="btn btn-default btn-xs dropdown-toggle"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        View <span class="caret"></span>
      </button>
      <ul class="dropdown-menu" style="z-index: 20000">
        <li (click)="showProcessingProgress()">
          <a href="javascript:void(0)">Processing Progress</a>
        </li>
      </ul>
    </div>
  `,
  standalone: false
})
export class RemitViewRendererComponent implements AgRendererComponent {
  public params: any

  agInit(params: any): void {
    this.params = params
  }

  refresh(params: any): boolean {
    return false
  }

  showProcessingProgress(): void {
    this.params.context.showProcessingProgressHandler(this.params.data)
  }
}
